






















import { Component, Vue, PropSync } from 'vue-property-decorator';
import { Dialog, Button } from 'element-ui';

@Component({
  components: {
    'el-dialog': Dialog,
    'el-button': Button,
  },
})
export default class AboutDialog extends Vue {
  @PropSync('showDialog', { type: Boolean, default: false }) private show!: boolean;
}
